import { configureStore } from '@reduxjs/toolkit'
import  vReducer  from './reducer'
export const store = configureStore({
    reducer: {
        vstore: vReducer
    },
    devTools: process.env.NODE_ENV !== 'production',
})